import React, { useState, useEffect } from "react";
import { SocialWrapper, Dropdown, DropdownItem } from "../styles";
import { getInitialSocialMediaListValues } from "../utils/helperFunctions";

type SocialMediaPickerProps = {
  addonBefore?: string | string[];
  placeholder?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
};

const SocialMediaPicker: React.FC<SocialMediaPickerProps> = ({
  addonBefore,
  placeholder = "Enter your username or profile link here...",
  value,
  onChange,
}) => {

  const newValuesMap = getInitialSocialMediaListValues({addonBefore, value});
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  if (Object.keys(newValuesMap).length > 0 && !selectedOption) {
    const firstWithValue = Object.keys(newValuesMap)[0];
    setSelectedOption(firstWithValue);
  }

  const handleOptionChange = (newOption: string) => {
    setSelectedOption(newOption);
  };

  const handleInputChange = (inputValue: string) => {
    if (!selectedOption || !Array.isArray(addonBefore)) {
      onChange?.(inputValue);
      return;
    }

    const updatedValuesMap = {
      ...newValuesMap,
      [selectedOption]: inputValue
    };

    const valueArray = addonBefore.map(platform => updatedValuesMap[platform] || '');
    onChange(valueArray);
  };

  const renderAddonBefore = () => {
    if (Array.isArray(addonBefore)) {
      const hasValues = Object.values(newValuesMap).some(v => v);
      
      return (
        <Dropdown
          value={selectedOption || ''}
          onChange={handleOptionChange}
        >
          {!hasValues && (
            <DropdownItem value="" disabled>
              Select 
            </DropdownItem>
          )}
          {addonBefore.map((option, index) => (
            <DropdownItem 
              key={index} 
              value={option}
            >
              {option}
            </DropdownItem>
          ))}
        </Dropdown>
      );
    }
    return addonBefore ? <span>{addonBefore}</span> : null;
  };

  const getCurrentInputValue = () => {
    if (!Array.isArray(addonBefore)) {
      return typeof value === "string" ? value : "";
    }
    return selectedOption ? newValuesMap[selectedOption] || "" : "";
  };

  return (
    <SocialWrapper
      addonBefore={renderAddonBefore()}
      value={getCurrentInputValue()}
      onChange={(e) => handleInputChange(e.target.value)}
      placeholder={placeholder}
      disabled={Array.isArray(addonBefore) && !selectedOption}
    />
  );
};

export default SocialMediaPicker;